module.exports = __webpack_public_path__ + "img/logo-collapsed@2x.135e899a.png";